import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SocialSignIn } from '../../components/social-sign-in/social-sign-in';

@Component({
  selector: 'app-signup',
  imports: [FormsModule, RouterLink, SocialSignIn],
  templateUrl: './signup.html',
})
export class Signup {
  private auth = inject(AuthService);
  private router = inject(Router);

  protected readonly name = signal('');
  protected readonly email = signal('');
  protected readonly password = signal('');
  protected readonly submitting = signal(false);
  protected readonly error = signal<string | null>(null);
  // Only set when the provider redirect never started; a failed round-trip
  // comes back on /login instead, where the ?error= code is decoded.
  protected readonly socialError = signal<string | null>(null);

  protected async submit(): Promise<void> {
    if (this.submitting()) return;
    this.error.set(null);
    this.submitting.set(true);
    const { error } = await this.auth.signUp({
      name: this.name().trim(),
      email: this.email().trim(),
      password: this.password(),
    });
    this.submitting.set(false);
    if (error) {
      this.error.set(error);
      return;
    }
    void this.router.navigateByUrl('/dashboard');
  }
}
